export class GlobalConfiguration {
    public id: string;
    public serviceEmail: string;

    static fromDto(gc): GlobalConfiguration {
        if (!gc) {
          return null;
        }
    
        const globalConfiguration = new GlobalConfiguration();
    
        globalConfiguration.id                       = gc.id;
        globalConfiguration.serviceEmail            = gc.service_email;
    
        return globalConfiguration;
    }
  
    static toDto(gc: GlobalConfiguration): any {
      if (!gc) {
        return null;
      }
  
      return {
          id: gc.id,
          service_email: gc.serviceEmail
      }
    }
}
